
























  import Vue from 'vue';
  import { mixins } from 'vue-class-component';
  import { Component, Prop } from 'vue-property-decorator';
  import { xComponentMixin } from '../../../../components';
  import { VueCSSClasses } from '../../../../utils/types';
  import { facetsXModule } from '../../x-module';
  import FiltersInjectionMixin from './filters-injection.mixin';

  /**
   * Renders a list with a list item per each
   * {@link @empathyco/x-types#BooleanFilter} in the filters prop array.
   * Each list item has a scoped slot, passing the filter as slot prop.
   *
   * @public
   */
  @Component({
    mixins: [xComponentMixin(facetsXModule)]
  })
  export default class FiltersList extends mixins(FiltersInjectionMixin) {
    /**
     * Animation component that will be used to animate the base filters.
     *
     * @public
     */
    @Prop({ default: 'ul' })
    protected animation!: Vue | string;

    /**
     * It handles if the filters should be rendered.
     *
     * @returns True if there are filters.
     *
     * @public
     */
    protected get hasFiltersToRender(): boolean {
      return this.renderedFilters?.length > 0;
    }

    /**
     * Checks if at least one filter is selected.
     *
     * @returns True if at least one filter is selected. False otherwise.
     * @internal
     */
    protected get hasSelectedFilters(): boolean {
      return !!this.renderedFilters?.some(filter => filter.selected);
    }

    /**
     * Dynamic CSS classes for the root element of this component.
     *
     * @returns An object containing the dynamic CSS classes and a boolean indicating if they should
     * be added or not.
     */
    protected get cssClasses(): VueCSSClasses {
      return {
        'x-filters--has-selected-filters': this.hasSelectedFilters
      };
    }
  }
